import React from "react";
import "../../../assets/css/Footer.css";

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="booking-footer">
      <div className="bf-main">
        {/* Column 1 — Address */}
        <div className="bf-col">
          <span className="bf-label">Headquarters</span>
          <div className="bf-address">
            <p>PELELOAN, KEC</p>
            <p>TONDANO SEL</p>
            <p>KABUPATEN MINAHASA</p>
            <p>SULAWESI UTARA 95619.</p>
          </div>
          <button
            className="bf-map-link"
            onClick={() =>
              window.open(
                "https://www.google.com/maps/place/%C3%80+L%E2%80%99AISE/@1.2428539,124.8918687,17z/data=!3m1!4b1!4m6!3m5!1s0x328715027db6a3f1:0x7191a9569d283b1b!8m2!3d1.2428539!4d124.8944436!16s%2Fg%2F11swxxnm2r?entry=ttu&g_ep=EgoyMDI1MDcyOS4wIKXMDSoASAFQAw%3D%3D",
                "_blank"
              )
            }
          >
            View on map <span className="bf-arrow">→</span>
          </button>
        </div>

        {/* Column 2 — Hours */}
        <div className="bf-col bf-col--center">
          <span className="bf-label">Opening Hours</span>
          <span className="bf-hours-day">MONDAY — SUNDAY</span>
          <span className="bf-hours-time">09:00 – 21:00</span>
          <div className="bf-ornament" />
        </div>

        {/* Column 3 — Social */}
        <div className="bf-col bf-col--right">
          <span className="bf-label">Connect</span>
          <div className="bf-socials">
            <button
              className="bf-social-btn"
              aria-label="Instagram"
              onClick={() =>
                window.open(
                  "https://www.instagram.com/alaise.bythelake/",
                  "_blank"
                )
              }
            >
              <InstagramIcon />
            </button>
            <button
              className="bf-social-btn"
              aria-label="WhatsApp"
              onClick={() =>
                window.open("https://wa.me/628218761080", "_blank")
              }
            >
              <WhatsAppIcon />
            </button>
          </div>
          <div className="bf-ornament" />
        </div>
      </div>

      {/* Bottom bar */}
      <div className="bf-bottom">
        <div className="bf-bottom-inner">
          <div className="bf-bottom-left">
            <span>Term & Conds</span>
            <span>Privacy Policy</span>
          </div>
          <div className="bf-bottom-right">
            <span>© À L'AISE 2026</span>
            <span className="sr-only">
              Website designed and developed by Codelune (https://www.codelune.site)
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;